// SPG payment methods, as the server names them in the SPG entry's supportedPaymentMethods.
export const SPG_MBWAY = 'MBWAY';
export const SPG_CARD = 'CARD';

// A server that does not send the list yet keeps offering both.
const SPG_DEFAULT_PAYMENT_METHODS = [SPG_MBWAY, SPG_CARD];

// The SPG payment methods the machine's gateway cashless allows, read from its entry in
// vendingMachineInfo.paymentTerminals (the gateway's methods that its POS ID also supports).
export const getSpgPaymentMethods = (spgPaymentTerminal: any): string[] => (
  Array.isArray(spgPaymentTerminal?.supportedPaymentMethods)
    ? spgPaymentTerminal.supportedPaymentMethods
    : SPG_DEFAULT_PAYMENT_METHODS
);
